export class File4Participant {
    participants: string;
}
